// Shared booking vocabulary + French labels + badge styles (Phase 2).

export const BOOKING_STATUS = {
  CONFIRMED: { label: "Confirmée", cls: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  CHECKED_IN: { label: "Client arrivé", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  IN_PROGRESS: { label: "En cours", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  COMPLETED: { label: "Terminée", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  CANCELLED: { label: "Annulée", cls: "bg-slate-100 text-slate-500 border-slate-300" },
  NO_SHOW: { label: "Absent", cls: "bg-rose-50 text-rose-700 border-rose-200" },
};

export const PAYMENT_STATUS = {
  UNPAID: { label: "À payer", cls: "bg-rose-50 text-rose-700 border-rose-200" },
  PAID: { label: "Payé", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
};

export const SOURCES = {
  WHATSAPP: "WhatsApp", PHONE: "Téléphone", WALK_IN: "Sur place",
  INSTAGRAM: "Instagram", HOTEL: "Hôtel", PARTNER: "Partenaire", OTHER: "Autre",
};

export const PAYMENT_METHODS = {
  cash: "Espèces", card: "Carte", transfer: "Virement", other: "Autre",
};

export const STATUS_LIST = Object.keys(BOOKING_STATUS);
export const SOURCE_LIST = Object.keys(SOURCES);
export const TIME_SLOTS = Array.from({ length: 31 }, (_, i) => {
  const m = 7 * 60 + i * 30;
  return `${String(Math.floor(m / 60)).padStart(2, "0")}:${String(m % 60).padStart(2, "0")}`;
});
